import { SET_HEADER_HEIGHT, SET_LAYOUT_WIDTH, SET_NAV_LOGO_MARGIN_WIDTH } from "../Types";

const savedWidth = localStorage.getItem("layout_width");
const savedLogoMargin = localStorage.getItem("nav_logo_margin_width");

const initialState = {
  header_height: 0,
  layout_width: savedWidth ? parseInt(savedWidth, 10) : 70, // hydrate from localStorage
  nav_logo_margin_width: savedLogoMargin ? parseInt(savedLogoMargin, 10) : 0, // hydrate from localStorage
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_HEADER_HEIGHT:
      return {
        ...state,
        header_height: payload,
      };
    case SET_LAYOUT_WIDTH:
      return {
        ...state,
        layout_width: payload,
      };
    case SET_NAV_LOGO_MARGIN_WIDTH:
      return {
        ...state,
        nav_logo_margin_width: payload,
      };
    default:
      return state;
  }
}
